module.exports = __webpack_public_path__ + "img/apoiase.a36bda75.svg";